import React from 'react'
import GmpmanualAccountTaskList from '../../../features/GmpManualAccount/GmpmanualAccountTaskList'

const ViewManualAccountList = () => {
  return (
    <div>
      <GmpmanualAccountTaskList />
    </div>
  )
}

export default ViewManualAccountList
